
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dzOK8", function(module, exports) {
/* TemplatePanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $hR4U4 = parcelRequire("hR4U4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");











var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $h7YX1 = parcelRequire("h7YX1");


var $gj7hi = parcelRequire("gj7hi");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $3NKT1 = parcelRequire("3NKT1");


var $6WOIb = parcelRequire("6WOIb");

var $1e46fde81a624910$exports = {};
$1e46fde81a624910$exports = new URL("write-illustration-dark.2d647139.svg", import.meta.url).toString();


var $afe0af9d5f7b66ee$exports = {};
$afe0af9d5f7b66ee$exports = new URL("write-illustration-light.344a3074.svg", import.meta.url).toString();


const $b72353cd64e01667$var$displayConfig = {
    compact: {
        illustrationSize: 64,
        gap: 'space.200'
    },
    wide: {
        illustrationSize: 88,
        gap: 'space.250'
    }
};
const $b72353cd64e01667$var$styles = {
    frame: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1mouv47k _vchhusvi _1wpz1fhb",
    spacingCompact: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    spacingWide: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k",
    illustration: "_1o9zidpf"
};
const $b72353cd64e01667$export$561362a11b942d9a = ({ onCreateWithRovo: onCreateWithRovo, contentType: contentType, display: display = 'compact' })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3NKT1.useFireAnalyticsEvent)();
    const hasScreenFired = (0, $42omo.useRef)(false); // Fire screen event on first render
    (0, $42omo.useEffect)(()=>{
        if (!hasScreenFired.current) {
            hasScreenFired.current = true;
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'rovoTemplatesCallout',
                attributes: {
                    contentType: contentType
                }
            });
        }
    }, [
        fireAnalyticsEvent,
        contentType
    ]);
    const handleCreateWithRovoClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoButton',
            attributes: {
                contentType: contentType
            }
        });
        onCreateWithRovo?.();
    }, [
        onCreateWithRovo,
        fireAnalyticsEvent,
        contentType
    ]);
    const config = $b72353cd64e01667$var$displayConfig[display];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($b72353cd64e01667$var$styles.frame, display === 'wide' ? $b72353cd64e01667$var$styles.spacingWide : $b72353cd64e01667$var$styles.spacingCompact),
        justifyContent: "center",
        alignItems: "center",
        gap: config.gap,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $b72353cd64e01667$var$styles.illustration
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($afe0af9d5f7b66ee$exports))),
                    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1e46fde81a624910$exports))),
                    alt: "",
                    width: config.illustrationSize,
                    height: config.illustrationSize
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                grow: "fill",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: intl.formatMessage((0, $6WOIb.rovoTemplatesCalloutMessages).title)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        children: intl.formatMessage((0, $6WOIb.rovoTemplatesCalloutMessages).description)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        space: "space.050",
                        shouldWrap: true,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
                            onClick: handleCreateWithRovoClick,
                            children: intl.formatMessage((0, $6WOIb.rovoTemplatesCalloutMessages).createWithRovo)
                        })
                    })
                ]
            })
        ]
    });
};



var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $kRW4Y = parcelRequire("kRW4Y");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $3IBnw = parcelRequire("3IBnw");


var $f9jv7 = parcelRequire("f9jv7");


var $4PPzL = parcelRequire("4PPzL");


var $5ZqQS = parcelRequire("5ZqQS");


var $2YJkl = parcelRequire("2YJkl");


var $bQm3c = parcelRequire("bQm3c");





var $jmjWc = parcelRequire("jmjWc");





var $2sWSU = parcelRequire("2sWSU");


var $eZElj = parcelRequire("eZElj");


var $6f6I4 = parcelRequire("6f6I4");


var $dMoBp = parcelRequire("dMoBp");

const $9b4115efa874c109$export$a2f4ce8c905213ca = ({ length: length = 3 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-list-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.CategoriesWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2sWSU.CategorySelector), {
        categories: [],
        isLoading: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.SortByWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eZElj.LoadingSortByDropdown), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f6I4.LoadingTemplateListCards), {
        length: length
    }));
};



const $f1cf196ddcf071a3$export$ae860fe076b4ba9f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Fsqx",
    name: "TemplateListLoader",
    loader: async ()=>(await (parcelRequire("i7ABN"))).TemplateList,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9b4115efa874c109$export$a2f4ce8c905213ca), null)
});









var $jhwJP = parcelRequire("jhwJP");


var $cqmCC = parcelRequire("cqmCC");

var $947821ad90c0db80$export$10e8e1cf990558d7 = /*#__PURE__*/ function(ErrorCodes) {
    ErrorCodes[ErrorCodes["VALIDATION_ERROR"] = 400] = "VALIDATION_ERROR";
    ErrorCodes[ErrorCodes["AUTHORIZATION_ERROR"] = 401] = "AUTHORIZATION_ERROR";
    ErrorCodes[ErrorCodes["NOT_FOUND_ERROR"] = 404] = "NOT_FOUND_ERROR";
    ErrorCodes[ErrorCodes["CONTENT_ERROR"] = 500] = "CONTENT_ERROR";
    return ErrorCodes;
}({});
const $947821ad90c0db80$var$i18nBase = (0, $aXWIB.defineMessages)({
    validationErrorTitle: {
        id: "template-utils.errors.validation.template.select.title",
        defaultMessage: "We couldn\u2019t load the template"
    },
    validationErrorDescription: {
        id: "template-utils.errors.validation.template.select.description",
        defaultMessage: "Try a different template, or create a new page and select the template again."
    },
    authorizationErrorTitle: {
        id: "template-utils.errors.authorization.template.select.title",
        defaultMessage: "We couldn\u2019t load the template"
    },
    authorizationErrorDescription: {
        id: "template-utils.errors.authorization.template.select.description",
        defaultMessage: "Try refreshing the page."
    },
    contentErrorTitle: {
        id: "template-utils.errors.content.template.select.title",
        defaultMessage: "We can\u2019t apply templates here"
    },
    contentErrorDescription: {
        id: "template-utils.errors.content.template.select.description",
        defaultMessage: "Try creating a new page and selecting the template again."
    },
    contentErrorDescriptionLiveDoc: {
        id: "template-utils.errors.content.template.select.description.livedocs",
        defaultMessage: "Try creating a new live doc and selecting the template again."
    },
    thirdPartyBlueprintErrorTitle: {
        id: "template-utils.errors.third.party.blueprint.template.select.title",
        defaultMessage: "This template is broken"
    },
    thirdPartyBlueprintErrorDescription: {
        id: "template-utils.errors.third.party.blueprint.template.select.description",
        defaultMessage: "Since the template is owned by a third-party, it has to be fixed by them. Contact your site admin so they can troubleshoot the issue."
    },
    editedFirstPartyBlueprintErrorTitle: {
        id: "template-utils.errors.edited.first.party.blueprint.template.select.title",
        defaultMessage: "This template is broken"
    },
    editedFirstPartyBlueprintErrorDescription: {
        id: "template-utils.errors.edited.first.party.blueprint.template.select.description",
        defaultMessage: "It contains elements that are no longer supported in the Confluence editor."
    },
    editedFirstPartyBlueprintErrorAction: {
        id: "template-utils.errors.edited.first.party.blueprint.template.select.action",
        defaultMessage: "Contact support"
    },
    notFoundErrorTitle: {
        id: "template-utils.errors.graphql.not.found.description.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn\u2019t create new content here"
    },
    notFoundErrorDescription: {
        id: "template-utils.errors.graphql.not.found.description",
        defaultMessage: "Refresh the page to try again."
    }
});
const $947821ad90c0db80$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    validationErrorDescription: {
        id: "template-utils.errors.validation.template.select.description.livedocs",
        defaultMessage: "Try a different template, or create a new page or live doc and select the template again."
    }
});
const $947821ad90c0db80$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($947821ad90c0db80$var$i18nBase, $947821ad90c0db80$var$i18nLiveDocs);
const $947821ad90c0db80$export$82f46aa4e6535a45 = ({ errorCode: errorCode, isThirdPartyBlueprintError: isThirdPartyBlueprintError, isEditedFirstPartyBlueprintError: isEditedFirstPartyBlueprintError, isLivePage: isLivePage })=>{
    if (errorCode === 400) return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.validationErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.validationErrorDescription)
    };
    if (errorCode === 404) return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.notFoundErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.notFoundErrorDescription)
    };
    if (errorCode === 500 && isThirdPartyBlueprintError) return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.thirdPartyBlueprintErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.thirdPartyBlueprintErrorDescription)
    };
    if (errorCode === 500 && isEditedFirstPartyBlueprintError) return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.editedFirstPartyBlueprintErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.editedFirstPartyBlueprintErrorDescription),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.editedFirstPartyBlueprintErrorAction),
                href: (0, $cqmCC.ATLASSIAN_SUPPORT_URL),
                target: '_blank'
            }
        ]
    };
    if (errorCode === 500) return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.contentErrorTitle),
        description: isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.contentErrorDescriptionLiveDoc) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.contentErrorDescription)
    };
    return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.authorizationErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $947821ad90c0db80$export$a7357cdd1f0b0168.authorizationErrorDescription)
    };
};



var $jn9ek = parcelRequire("jn9ek");


var $10Oe6 = parcelRequire("10Oe6");


var $lJDEI = parcelRequire("lJDEI");


var $8hUXc = parcelRequire("8hUXc");


var $6fil2 = parcelRequire("6fil2");


var $7Sm4c = parcelRequire("7Sm4c");


var $dPJCf = parcelRequire("dPJCf");


var $7zgzO = parcelRequire("7zgzO");


var $3jwuS = parcelRequire("3jwuS");


var $1AJi3 = parcelRequire("1AJi3");





var $1A7bE = parcelRequire("1A7bE");

const $3988454930441830$export$8934ed43fd50f138 = (events, experience)=>{
    (0, $1A7bE.collectAll)([
        (0, $irVI7.CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE)
    ])(events, experience);
};
const $3988454930441830$export$3ee847403467b65f = (events, experience)=>{
    (0, $1A7bE.collectAll)([
        (0, $irVI7.CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE),
        (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE)
    ])(events, experience);
};









var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $hArLp = parcelRequire("hArLp");





var $7gpC4 = parcelRequire("7gpC4");
















// for analytics
const $4c16a25270cbb0ab$var$SCREEN_NAME = 'overwriteWarningModal';
const $4c16a25270cbb0ab$var$i18nBase = (0, $aXWIB.defineMessages)({
    overwriteWarningModalDialogTitle: {
        id: "template-panel.overwrite-warning-modal.title",
        defaultMessage: "Select this template?"
    },
    overwriteWarningModalDialogBodyText: {
        id: "template-panel.overwrite-warning-modal.body",
        defaultMessage: "Existing content will be removed and replaced with the selected template."
    },
    overwriteWarningCheckBoxText: {
        id: "template-panel.overwrite-warning-modal.checkbox.description",
        defaultMessage: "Or, keep this page and start new page"
    },
    overwriteWarningCancelButtonText: {
        id: "template-panel.overwrite-warning-modal.button.cancel",
        defaultMessage: "Cancel"
    },
    overwriteWarningConfirmButtonText: {
        id: "template-panel.overwrite-warning-modal.button.confirm",
        defaultMessage: "Confirm"
    }
});
const $4c16a25270cbb0ab$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    overwriteWarningCheckBoxText: {
        id: "template-panel.overwrite-warning-modal.checkbox.description.livedocs",
        defaultMessage: "Or, keep this content and start a new page or doc"
    }
});
const $4c16a25270cbb0ab$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($4c16a25270cbb0ab$var$i18nBase, $4c16a25270cbb0ab$var$i18nLiveDocs);
const $4c16a25270cbb0ab$export$4cdfc1e90d64cbb4 = /*#__PURE__*/ (0, $42omo.memo)(({ onClose: onClose, onCreate: onCreate, template: template })=>{
    const [createNewPage, setCreateNewPage] = (0, $42omo.useState)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // screen event should be triggered once
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $4c16a25270cbb0ab$var$SCREEN_NAME,
                attributes: {
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template),
                    isLivePage: isLivePage
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleReplaceCurrentPageToggle = (event)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'toggled',
                actionSubject: 'option',
                actionSubjectId: 'createNewPageOption',
                source: $4c16a25270cbb0ab$var$SCREEN_NAME,
                attributes: {
                    createNewPage: createNewPage,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        setCreateNewPage(event.target.checked);
    };
    const handleOnClickCancel = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overwriteWarningModalCancel',
                source: $4c16a25270cbb0ab$var$SCREEN_NAME,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
        onClose();
    };
    const handleOnClickConfirm = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overwriteWarningModalConfirm',
                source: $4c16a25270cbb0ab$var$SCREEN_NAME,
                attributes: {
                    createNewPage: createNewPage,
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template),
                    isLivePage: isLivePage
                }
            }
        }).fire();
        onCreate(template, !createNewPage);
        // need to close the dialog because it overrides the blueprint wizard's input focus
        onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: handleOnClickCancel,
        width: 400,
        testId: "overwrite-warning-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4c16a25270cbb0ab$var$i18n.overwriteWarningModalDialogTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4c16a25270cbb0ab$var$i18n.overwriteWarningModalDialogBodyText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        testId: "overwrite-warning-modal-create-new-page-checkbox",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4c16a25270cbb0ab$var$i18n.overwriteWarningCheckBoxText),
        onChange: handleReplaceCurrentPageToggle,
        name: "overwrite-warning-modal-create-new-page-checkbox"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "overwrite-warning-modal-button-cancel",
        onClick: handleOnClickCancel,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4c16a25270cbb0ab$var$i18n.overwriteWarningCancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "overwrite-warning-modal-button-confirm",
        onClick: handleOnClickConfirm,
        appearance: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4c16a25270cbb0ab$var$i18n.overwriteWarningConfirmButtonText)))));
});





















var $eEA8O = parcelRequire("eEA8O");


var $ebrpi = parcelRequire("ebrpi");













const $bf63e5abf91291b9$export$a7b838d842f421d1 = ({ discardDraftDefault: discardDraftDefault = false, onClose: onClose, onCreate: onCreate, template: template })=>{
    const [discardDraft, setDiscardDraft] = (0, $42omo.useState)(discardDraftDefault);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // screen event should be triggered once
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                source: 'templateCreateNewPageDialogModal',
                name: 'templateCreateNewPageDialogModalScreen',
                attributes: {
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template)
                }
            }
        }).fire();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const onCloseHandler = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'discardDraftCancel',
                source: 'templateCreateNewPageDialogModal'
            }
        }).fire();
        onClose();
    };
    const discardDraftToggle = (event)=>{
        const toggledState = event.target.checked;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'toggled',
                actionSubject: 'option',
                actionSubjectId: 'discardDraftOption',
                source: 'templateCreateNewPageDialogModal',
                attributes: {
                    toggled: toggledState
                }
            }
        }).fire();
        setDiscardDraft(toggledState);
    };
    const onCreateHandler = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'discardDraftCreate',
                source: 'templateCreateNewPageDialogModal',
                attributes: {
                    toggled: discardDraft,
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template)
                }
            }
        }).fire();
        onCreate(template, discardDraft);
        // need to close the dialog because it overrides the blueprint wizard's input focus
        onClose();
    };
    return {
        discardDraftToggle: discardDraftToggle,
        onCloseHandler: onCloseHandler,
        onCreateHandler: onCreateHandler
    };
};


/* DiscardChangesModalStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ // right-align the dialog actions in the footer
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766






const $3d20e72488d8415a$export$6f85644dafe908c8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq _n3td1ejb",
            __cmplp.className
        ])
    });
});
const $3d20e72488d8415a$export$6c1ad2c32ba9516c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $3d20e72488d8415a$export$c0c486b9cdcca834 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _16zbutpp",
            __cmplp.className
        ])
    });
});


const $b5b0a9a89d1e9b44$var$i18nBase = (0, $aXWIB.defineMessages)({
    discardChangesModalDialogTitle: {
        id: "template-panel.always-discard-modal.title",
        defaultMessage: "Replace existing content with template?"
    },
    discardChangesModalDialogTitleWarning: {
        id: "template-panel.always-discard-modal.title.warning",
        defaultMessage: "Warning"
    },
    discardChangesCancelButtonText: {
        id: "template-panel.always-discard-modal.button.cancel",
        defaultMessage: "Cancel"
    },
    discardChangesCreateButtonText: {
        id: "template-panel.always-discard-modal.button.create",
        defaultMessage: "Replace content"
    },
    discardChangesModalDialogBodyText: {
        id: "template-panel.always-discard-modal.body",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "The content you've created so far will be lost. To use a template without losing your work, create a new page and select a template before adding any content."
    }
});
const $b5b0a9a89d1e9b44$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    discardChangesModalDialogBodyText: {
        id: "template-panel.always-discard-modal.body.livedocs",
        defaultMessage: "The content you\u2019ve created so far will be lost. To use a template without losing your work, create a new page or live doc and select a template before adding any content."
    }
});
const $b5b0a9a89d1e9b44$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($b5b0a9a89d1e9b44$var$i18nBase, $b5b0a9a89d1e9b44$var$i18nLiveDocs);
const $b5b0a9a89d1e9b44$export$fc6d4d24b59e73de = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ onClose: onClose, onCreate: onCreate, template: template })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { onCreateHandler: onCreateHandler, onCloseHandler: onCloseHandler } = (0, $bf63e5abf91291b9$export$a7b838d842f421d1)({
        discardDraftDefault: true,
        onClose: onClose,
        onCreate: onCreate,
        template: template
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: onCloseHandler,
        width: 480,
        testId: "always-discard-changes-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3d20e72488d8415a$export$c0c486b9cdcca834), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        spacing: "spacious",
        color: "var(--ds-icon-warning, #E06C00)",
        label: intl.formatMessage($b5b0a9a89d1e9b44$var$i18n.discardChangesModalDialogTitleWarning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b5b0a9a89d1e9b44$var$i18n.discardChangesModalDialogTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b5b0a9a89d1e9b44$var$i18n.discardChangesModalDialogBodyText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3d20e72488d8415a$export$6c1ad2c32ba9516c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3d20e72488d8415a$export$6f85644dafe908c8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "always-discard-changes-modal-button-cancel",
        onClick: onCloseHandler,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b5b0a9a89d1e9b44$var$i18n.discardChangesCancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "always-discard-changes-modal-button-create-primary",
        onClick: onCreateHandler,
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b5b0a9a89d1e9b44$var$i18n.discardChangesCreateButtonText)))))));
});









var $6sN9o = parcelRequire("6sN9o");

const $5f6f117a897504cd$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    searchBarLabel: {
        id: "template-panel.label",
        defaultMessage: "Templates"
    },
    searchTemplateDataPlaceholderText: {
        id: "template-panel.search.hintText",
        defaultMessage: "Search author, category, topic"
    }
});
const $5f6f117a897504cd$export$79d13b60110f33be = ({ ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6sN9o.DebouncedSearchBar), {
        label: intl.formatMessage($5f6f117a897504cd$export$a7357cdd1f0b0168.searchBarLabel),
        testId: "search-templates",
        placeholder: intl.formatMessage($5f6f117a897504cd$export$a7357cdd1f0b0168.searchTemplateDataPlaceholderText),
        isCompact: true,
        ...props
    });
};


/* TemplatePanelSpaceSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $caYQd = parcelRequire("caYQd");

const $9e8f104b77b2fe94$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    spaceSelectorLabel: {
        id: "template-panel.space-selector.label",
        defaultMessage: "Select a template from this space"
    }
});
const $9e8f104b77b2fe94$var$TEMPLATE_PANEL_SPACE_SELECTOR = 'template-panel-space-selector';
const $9e8f104b77b2fe94$var$spaceSelectorWrapperStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e8f104b77b2fe94$var$SpaceSelectorLabel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _k48pwu06 _syazazsu _19pkutpp _otyr1b66",
            __cmplp.className
        ])
    });
});
const $9e8f104b77b2fe94$var$requiredSpaceOperations = [
    {
        targetType: 'page',
        operation: 'create'
    },
    {
        targetType: 'blogpost',
        operation: 'create'
    }
];
const $9e8f104b77b2fe94$export$65712f4dd54220b3 = ({ onChange: onChange, spaceKey: spaceKey, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9e8f104b77b2fe94$var$spaceSelectorWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e8f104b77b2fe94$var$SpaceSelectorLabel, {
        htmlFor: $9e8f104b77b2fe94$var$TEMPLATE_PANEL_SPACE_SELECTOR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $9e8f104b77b2fe94$export$a7357cdd1f0b0168.spaceSelectorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caYQd.SpaceSelector), {
        onChange: onChange,
        spaceKey: spaceKey,
        isDisabled: isDisabled,
        operationsUsedToDetermineRestrictedStatus: $9e8f104b77b2fe94$var$requiredSpaceOperations,
        showRestrictedSpaces: false,
        filterDefaultFromResults: false,
        showSpaceLabel: false,
        filterStarredFromRecent: true,
        selectSpacing: "compact",
        id: $9e8f104b77b2fe94$var$TEMPLATE_PANEL_SPACE_SELECTOR
    })));
};


const $b792e248bae3af96$var$PanelWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b792e248bae3af96$var$InputFieldsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4otz2",
            __cmplp.className
        ])
    });
});
const $b792e248bae3af96$var$templateListWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
var $b792e248bae3af96$export$10e8e1cf990558d7 = /*#__PURE__*/ function(ErrorCodes) {
    ErrorCodes[ErrorCodes["VALIDATION_ERROR"] = 400] = "VALIDATION_ERROR";
    ErrorCodes[ErrorCodes["AUTHORIZATION_ERROR"] = 401] = "AUTHORIZATION_ERROR";
    ErrorCodes[ErrorCodes["NOT_FOUND_ERROR"] = 404] = "NOT_FOUND_ERROR";
    ErrorCodes[ErrorCodes["CONTENT_ERROR"] = 500] = "CONTENT_ERROR";
    return ErrorCodes;
}({});
const $b792e248bae3af96$export$67b0eaa8bfcb2d1f = (0, $7aRa9.withFlags)(({ isPanelDisabled: isPanelDisabled = false, parentPageId: parentPageId, currentSpaceKey: currentSpaceKey, contentId: contentId, onContentUpdated: onContentUpdated, beforeUpdateRequest: beforeUpdateRequest, beforeTemplateSelect: beforeTemplateSelect, hasUserAddedContent: hasUserAddedContent, title: title, flags: flags, onError: onError, templateAllowList: templateAllowList, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const intl = (0, $aXWIB.useIntl)();
    const { userId: currentUserId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant, isConversationAssistantSidebarActive: isConversationAssistantSidebarActive } = (0, $1AJi3.useToggleConversationAssistant)();
    const { setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { showBlueprintVariableWizard: showBlueprintVariableWizard, showTemplateVariableInputDrawer: showTemplateVariableInputDrawer } = (0, $42omo.useContext)((0, $8hUXc.CreateDialogContext));
    const createFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const [selectedSpaceKey, setSelectedSpaceKey] = (0, $42omo.useState)(currentSpaceKey);
    const [searchQuery, setSearchQuery] = (0, $42omo.useState)('');
    const [selectedTemplateKey, setSelectedTemplateKey] = (0, $42omo.useState)('');
    const [isDisabled, setIsDisabled] = (0, $42omo.useState)(isPanelDisabled);
    const [isCreating, setIsCreating] = (0, $42omo.useState)(false);
    const onCreateWithRovoCallback = (0, $42omo.useCallback)(()=>{
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams, isRovoLLMEnabled);
        // Only toggle if CWR is not already open (in sidebar or mini-modal mode)
        if (!isConversationAssistantSidebarActive && mode !== (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL) toggleConversationAssistant('mini-modal');
    }, [
        setQueryParams,
        toggleConversationAssistant,
        isConversationAssistantSidebarActive,
        mode,
        isRovoLLMEnabled
    ]);
    // These variables needed for analytic events.
    // No need to put them into `state`, since they are not
    // rendered
    const hasSpaceChanged = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (showTemplateVariableInputDrawer || showBlueprintVariableWizard || isPanelDisabled || isCreating) setIsDisabled(true);
        else {
            setIsDisabled(false); // @Todo CTE-337 reset value of stored template until dialog close callback is made
            setSelectedTemplateKey('');
        }
    }, [
        isCreating,
        showTemplateVariableInputDrawer,
        showBlueprintVariableWizard,
        isPanelDisabled
    ]);
    const handleError = (e)=>{
        onError && onError();
        const errorCode = e?.graphQLErrors?.[0]?.originalError?.response?.status;
        const isNotFoundGraphqlError = (0, $f9jv7.isNotFoundError)(e);
        const isThirdPartyBlueprintError = (0, $jn9ek.isBadThirdPartyBlueprintError)(e);
        const isEditedFirstPartyBlueprintError = (0, $jn9ek.isBadEditedFirstPartyBlueprintError)(e);
        const isNoNetworkError = (0, $6fil2.containsNetworkError)(e);
        flags.showErrorFlag((0, $947821ad90c0db80$export$82f46aa4e6535a45)({
            errorCode: errorCode,
            isThirdPartyBlueprintError: isThirdPartyBlueprintError,
            isEditedFirstPartyBlueprintError: isEditedFirstPartyBlueprintError,
            isLivePage: isCurrentPageLive
        }));
        if (isThirdPartyBlueprintError || isEditedFirstPartyBlueprintError || isNotFoundGraphqlError || isNoNetworkError) {
            experienceTracker.succeed({
                name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_EXPERIENCE)
            });
            experienceTracker.abort({
                name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE),
                reason: isThirdPartyBlueprintError ? 'third party blueprint error' : isNotFoundGraphqlError ? 'not found graphql error' : isNoNetworkError ? 'no network error' : 'edited first party blueprint error'
            });
            if (isNoNetworkError) (0, $7Sm4c.markErrorAsHandled)(e);
        } else {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
            (0, $fGzMp.stopExperienceOnError)((0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_EXPERIENCE), e);
            (0, $fGzMp.stopExperienceOnError)((0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE), e);
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'error',
                actionSubject: 'editPageScreen',
                actionSubjectId: 'contentCreateWithTemplateError',
                attributes: {
                    errorMessage: e.message
                }
            }
        }).fire();
    };
    const handleSpaceChange = (0, $42omo.useCallback)(({ spaceKey: newSpaceKey })=>{
        setSelectedSpaceKey(newSpaceKey);
    }, [
        setSelectedSpaceKey
    ]);
    const handleSearchChange = (0, $42omo.useCallback)((searchQuery)=>{
        setSearchQuery(searchQuery);
    }, [
        setSearchQuery
    ]);
    const handleSearchFocus = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'templateDrawer',
                action: 'clicked',
                actionSubject: 'textField',
                actionSubjectId: 'templateSearchBar'
            }
        }).fire();
    };
    const closeDraftDiscardModal = ()=>{};
    const handleTemplateSelectWithModal = (dialogs)=>(template, additionalStatAttributes)=>{
            setSelectedTemplateKey((0, $10Oe6.getTemplateKey)(template));
            beforeTemplateSelect && beforeTemplateSelect();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'templateDrawer',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'templateOption',
                    attributes: {
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isCurrentPageLive,
                        searchQueryPresent: !!searchQuery.length,
                        spaceChanged: selectedSpaceKey !== currentSpaceKey,
                        ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template),
                        ...additionalStatAttributes,
                        searchQueryMatches: (0, $10Oe6.getSearchQueryMatches)(template, intl, currentUserId, searchQuery)
                    }
                }
            }).fire();
            hasSpaceChanged.current = false;
            if (hasUserAddedContent) {
                const modal = isAlwaysDiscardChanges ? (0, $b5b0a9a89d1e9b44$export$fc6d4d24b59e73de) : (0, $4c16a25270cbb0ab$export$4cdfc1e90d64cbb4);
                dialogs.showDialog(modal, {
                    onCreate: handleTemplateSelect,
                    onClose: closeDraftDiscardModal,
                    template: template
                });
            } else handleTemplateSelect(template);
        };
    const handleTemplateSelect = (template, replaceContent = true)=>{
        setIsCreating(true);
        const shouldInjectContent = replaceContent && contentId;
        experienceTracker.start({
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_EXPERIENCE),
            collect: shouldInjectContent ? (0, $3988454930441830$export$3ee847403467b65f) : (0, $3988454930441830$export$8934ed43fd50f138)
        });
        experienceTracker.start({
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR
        });
        const options = {
            ...onContentUpdated && {
                onContentUpdated: onContentUpdated
            },
            onVariableInputError: handleError,
            beforeUpdateRequest: beforeUpdateRequest,
            templateOriginSpaceKey: selectedSpaceKey,
            parentPageId: parentPageId,
            ...shouldInjectContent && {
                contentId: contentId
            },
            ...shouldInjectContent && title && {
                title: title
            },
            ...isCurrentPageLive && {
                subType: 'live'
            }
        };
        createFromTemplate(template, currentSpaceKey, options).then(()=>{
            setIsCreating(false);
        }).catch((e)=>{
            setIsCreating(false);
            handleError(e);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b792e248bae3af96$var$PanelWrapper, {
            "data-testid": "template-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b792e248bae3af96$var$InputFieldsWrapper, null, !isSpacePickerDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9e8f104b77b2fe94$export$65712f4dd54220b3), {
            onChange: handleSpaceChange,
            spaceKey: currentSpaceKey,
            isDisabled: isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f6f117a897504cd$export$79d13b60110f33be), {
            onChange: handleSearchChange,
            onFocus: handleSearchFocus,
            isDisabled: isDisabled
        })), isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b72353cd64e01667$export$561362a11b942d9a), {
            onCreateWithRovo: onCreateWithRovoCallback,
            contentType: isCurrentPageLive ? 'liveDoc' : 'page'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $b792e248bae3af96$var$templateListWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1cf196ddcf071a3$export$ae860fe076b4ba9f), {
            onTemplateSelect: handleTemplateSelectWithModal(dialogs),
            spaceKey: selectedSpaceKey,
            templateBlueprintAllowList: templateAllowList,
            currentSpaceKey: currentSpaceKey,
            searchQuery: searchQuery,
            selectedTemplateKey: selectedTemplateKey,
            isDisabled: isDisabled,
            hasHighlightBleed: true
        })))));
});
module.exports["ErrorCodes"] = $b792e248bae3af96$export$10e8e1cf990558d7;
module.exports["TemplatePanel"] = $b792e248bae3af96$export$67b0eaa8bfcb2d1f;

});

parcelRegister("3NKT1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");

const $71c7f0b56d63d40b$var$ANALYTICS_CHANNEL = (0, $3pfAb.FabricChannel).aiMate;
const $71c7f0b56d63d40b$var$ANALYTICS_SOURCE = 'conversationAssistantBlankObjectExperience';
const $71c7f0b56d63d40b$export$eed8c476984ddfad = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: $71c7f0b56d63d40b$var$ANALYTICS_SOURCE,
            attributes: {
                ...payload.attributes
            }
        }).fire($71c7f0b56d63d40b$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
module.exports["useFireAnalyticsEvent"] = $71c7f0b56d63d40b$export$eed8c476984ddfad;

});

parcelRegister("6WOIb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $66d71676abc43bb4$export$4dff720583db3e51 = (0, $aXWIB.defineMessages)({
    title: {
        id: "conversation-assistant-blank-object-experience.rovo-templates-callout.title",
        defaultMessage: "Can't find what you're looking for?"
    },
    description: {
        id: "conversation-assistant-blank-object-experience.rovo-templates-callout.description",
        defaultMessage: "Get help structuring and accelerating your work with Rovo."
    },
    createWithRovo: {
        id: "conversation-assistant-blank-object-experience.rovo-templates-callout.create-with-rovo",
        defaultMessage: "Create with Rovo"
    }
});
const $66d71676abc43bb4$export$3853ce9baa40aa72 = (0, $aXWIB.defineMessages)({
    close: {
        id: "blank-object-experience-modal.close",
        defaultMessage: "Close"
    },
    or: {
        id: "blank-object-experience-modal.or",
        defaultMessage: "or"
    },
    startFromTemplate: {
        id: "blank-object-experience-modal.start-from-template",
        defaultMessage: "Start from a template"
    },
    import: {
        id: "blank-object-experience-modal.import",
        defaultMessage: "Import"
    }
});
const $66d71676abc43bb4$export$bdf652ad8deddce2 = (0, $aXWIB.defineMessages)({
    loadingSmartPrompt: {
        id: "ai-mate.conversation-assistant-blank-object-experience.smart-prompt-skeleton.loading",
        defaultMessage: "Loading smart prompt"
    }
});
const $66d71676abc43bb4$export$3f9d1693b588f42f = (0, $aXWIB.defineMessages)({
    basedOnTemplate: {
        id: "conversation-assistant-blank-object-experience.templatePreview.basedOn",
        defaultMessage: "Based on {templateName} template"
    }
});
const $66d71676abc43bb4$export$20aa1f02090a897b = (0, $aXWIB.defineMessages)({
    moreButton: {
        id: "conversation-assistant-blank-object-experience.moreButton",
        defaultMessage: "More"
    }
});
module.exports["rovoTemplatesCalloutMessages"] = $66d71676abc43bb4$export$4dff720583db3e51;
module.exports["smartPromptSkeletonMessages"] = $66d71676abc43bb4$export$bdf652ad8deddce2;
module.exports["smartPromptsMoreButtonMessages"] = $66d71676abc43bb4$export$20aa1f02090a897b;

});

parcelRegister("eZElj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9cCqQ = parcelRequire("9cCqQ");

const $db3954d3652bf81a$export$ae0dc21448cee283 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cCqQ.SortByDropdownWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cCqQ.SortByDropdownLoading), {
        "data-testid": "templates-sort-by-dropdown-loader"
    }));
module.exports["LoadingSortByDropdown"] = $db3954d3652bf81a$export$ae0dc21448cee283;

});

parcelRegister("9cCqQ", function(module, exports) {
/* styles.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable check-file/filename-blocklist */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $20df0c3547d26cb3$export$b56b6757cfcf336d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syaz1rpy _k48p1wq8 _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $20df0c3547d26cb3$export$aea6dfcfba82045 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1q9y",
            __cmplp.className
        ])
    });
});
const $20df0c3547d26cb3$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $20df0c3547d26cb3$export$5b6c3bb63d565edb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsbuuw1 _bfhkizff _4t3izwfg",
            __cmplp.className
        ])
    });
});
module.exports["SortByLabel"] = $20df0c3547d26cb3$export$b56b6757cfcf336d;
module.exports["SortByDropdownWrapper"] = $20df0c3547d26cb3$export$aea6dfcfba82045;
module.exports["DropdownWrapper"] = $20df0c3547d26cb3$export$5f7211d21bfdae05;
module.exports["SortByDropdownLoading"] = $20df0c3547d26cb3$export$5b6c3bb63d565edb;

});

parcelRegister("6f6I4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dhnmv = parcelRequire("dhnmv");

/* LoadingTemplateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");




const $a62d3e35adedcc40$var$styles = {
    avatarItem: "_2rko12b0 _1yt4u2gc _1dqonqa1 _189e1dm9 _1h6d1j28 _1e0c1txw _4cvr1h6o _otyrpxbi",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _p12f1osq _bozgu2gc"
};
const $a62d3e35adedcc40$var$placeholderTitleStyles = null;
const $a62d3e35adedcc40$var$placeholderDescriptionStyles = null; // Using AVATAR_SIZES here was causing a compiled issue for whatever reason
const $a62d3e35adedcc40$var$defaultIconStyles = null;
const $a62d3e35adedcc40$export$2624772dc1837a9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-card-wrapper",
        className: (0, $gMc0m.default)([
            $a62d3e35adedcc40$var$styles.avatarItem
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-card-default-icon",
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3izwfg _1bsbzwfg _ca0q1b66 _y3gn1h6o _bfhkizff"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $a62d3e35adedcc40$var$styles.avatarItemTextWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3i7vkz _1bsbmlf1 _bfhkizff"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _19pk1b66 _4t3izwfg _bfhkizff"
        ])
    })));



var $c04Yn = parcelRequire("c04Yn");


var $jX1qB = parcelRequire("jX1qB");

const $b12e1e347cad37bc$export$2763c800d7538309 = ({ length: length = 3 })=>{
    (0, $42omo.useEffect)(()=>{
        (0, $dhnmv.PopupPreview).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-list-cards-loading"
    }, Array(length).fill(null).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a62d3e35adedcc40$export$2624772dc1837a9b), {
            key: index
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04Yn.PageSegmentLoadMark), {
        markName: "fmp",
        metricKey: (0, $jX1qB.IN_EDITOR_TEMPLATES_SEGMENT_KEY)
    }));
};
module.exports["LoadingTemplateListCards"] = $b12e1e347cad37bc$export$2763c800d7538309;

});

parcelRegister("dhnmv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9a42d0df36d411bd$export$65c74394172c28e5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2ysmR",
    name: "PopupPreview",
    loader: async ()=>(await (parcelRequire("dTxE3"))).PopupPreview
});
module.exports["PopupPreview"] = $9a42d0df36d411bd$export$65c74394172c28e5;

});

parcelRegister("dTxE3", function(module, exports) {

let $a1da82a13f8fcb20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1da82a13f8fcb20$var$load("cvmn7"),
    $a1da82a13f8fcb20$var$load("jmFg4"),
    $a1da82a13f8fcb20$var$load("4JDwd"),
    $a1da82a13f8fcb20$var$load("4wvcA"),
    $a1da82a13f8fcb20$var$load("iAqyW"),
    $a1da82a13f8fcb20$var$load("9nwFZ"),
    $a1da82a13f8fcb20$var$load("e1cuZ"),
    $a1da82a13f8fcb20$var$load("6kXh6"),
    $a1da82a13f8fcb20$var$load("hvHZS"),
    $a1da82a13f8fcb20$var$load("5NQgH"),
    $a1da82a13f8fcb20$var$load("daVOf"),
    $a1da82a13f8fcb20$var$load("enf8i"),
    $a1da82a13f8fcb20$var$load("Wowvf"),
    $a1da82a13f8fcb20$var$load("bupWa")
]).then(()=>parcelRequire('bEmzp'));

});

parcelRegister("dMoBp", function(module, exports) {
/* TemplateListStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e11cf7d5ef491c0b$export$a3d0558af3979721 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $e11cf7d5ef491c0b$export$a1d70406c7c51a07 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasBleed: hasBleed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.hasBleed ? "_18zrpxbi" : "_18zrze3t",
            __cmplp.hasBleed ? "_195gmgjw" : "_195gze3t",
            __cmplp.className
        ])
    });
});
const $e11cf7d5ef491c0b$export$2ddb1c92f566b7c1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s84hzm",
            __cmplp.className
        ])
    });
});
const $e11cf7d5ef491c0b$export$8d69e7a726bfcd31 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8774l",
            __cmplp.className
        ])
    });
});
const $e11cf7d5ef491c0b$export$e5ed137fe94ea7c3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1snh _4t3iuuw1 _3um015vq",
            __cmplp.className
        ])
    });
});
const $e11cf7d5ef491c0b$export$c3353785aded6059 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s82tda _ca0qv77o _syazi7uo",
            __cmplp.className
        ])
    });
});
module.exports["TemplateListContainer"] = $e11cf7d5ef491c0b$export$a3d0558af3979721;
module.exports["ListWrapper"] = $e11cf7d5ef491c0b$export$a1d70406c7c51a07;
module.exports["CategoriesWrapper"] = $e11cf7d5ef491c0b$export$2ddb1c92f566b7c1;
module.exports["SortByWrapper"] = $e11cf7d5ef491c0b$export$8d69e7a726bfcd31;
module.exports["InfiniteScrollWrapper"] = $e11cf7d5ef491c0b$export$e5ed137fe94ea7c3;
module.exports["CountDisplayWrapper"] = $e11cf7d5ef491c0b$export$c3353785aded6059;

});

parcelRegister("i7ABN", function(module, exports) {

let $d315472b9bd97eb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d315472b9bd97eb0$var$load("96ixK").then(()=>parcelRequire('lUWKo'));

});

parcelRegister("cqmCC", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");

const $1805b22ab5ce9c71$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $1805b22ab5ce9c71$var$getLinkText = (showHostname)=>showHostname ? (0, $jiJCD.parse)($1805b22ab5ce9c71$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    });
const $1805b22ab5ce9c71$export$f1bb9e069c7d2c = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { showHostname: showHostname, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showHostname) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : $1805b22ab5ce9c71$var$getLinkText(showHostname);
        $[0] = children;
        $[1] = showHostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: $1805b22ab5ce9c71$export$98c2bfe563916273,
            target: "_blank"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["ATLASSIAN_SUPPORT_URL"] = $1805b22ab5ce9c71$export$98c2bfe563916273;
module.exports["AtlassianSupportLink"] = $1805b22ab5ce9c71$export$f1bb9e069c7d2c;

});

parcelRegister("1AJi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("caYQd", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a745dfd537cdace3$var$LoadingSpaceSelector = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke1ylp",
            __cmplp.className
        ])
    });
});

const $a745dfd537cdace3$export$ae81af835e192ac4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SLEHS",
    name: "SpaceSelector",
    loader: async ()=>(await (parcelRequire("5xcKW"))).SpaceSelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a745dfd537cdace3$var$LoadingSpaceSelector, null)
});
module.exports["SpaceSelector"] = $a745dfd537cdace3$export$ae81af835e192ac4;

});

parcelRegister("5xcKW", function(module, exports) {

let $4079ede92511d45f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4079ede92511d45f$var$load("6wr18"),
    $4079ede92511d45f$var$load("dtpmo"),
    $4079ede92511d45f$var$load("jzz75"),
    $4079ede92511d45f$var$load("dbdNk"),
    $4079ede92511d45f$var$load("h5FT3"),
    $4079ede92511d45f$var$load("ffEVr"),
    $4079ede92511d45f$var$load("70hqB"),
    $4079ede92511d45f$var$load("8W6BK"),
    $4079ede92511d45f$var$load("6bVVs"),
    $4079ede92511d45f$var$load("7mo6o"),
    $4079ede92511d45f$var$load("eTYdV"),
    $4079ede92511d45f$var$load("9gVav"),
    $4079ede92511d45f$var$load("elrCw"),
    $4079ede92511d45f$var$load("cj0Rr"),
    $4079ede92511d45f$var$load("cvmn7"),
    $4079ede92511d45f$var$load("jmFg4"),
    $4079ede92511d45f$var$load("7EorR"),
    $4079ede92511d45f$var$load("hhss7"),
    $4079ede92511d45f$var$load("Wowvf"),
    $4079ede92511d45f$var$load("etEYy"),
    $4079ede92511d45f$var$load("h3ABO"),
    $4079ede92511d45f$var$load("kC80R"),
    $4079ede92511d45f$var$load("eMbU0")
]).then(()=>parcelRequire('bHtQ2'));

});

parcelRegister("bZ9Ng", function(module, exports) {
/* This module exports shared functions used by both blueprint & template endpoints, as these REST APIs share similar
 * request/response patterns.
 */ // eslint-disable-next-line no-restricted-imports

var $hBkCm = parcelRequire("hBkCm");


var $dw6y2 = parcelRequire("dw6y2");

const $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f = (json)=>{
    const title = json?.content?.title;
    return {
        content: {
            id: json?.content?.id || null,
            type: 'page',
            subType: json?.content?.subType || null,
            title: typeof title === 'string' ? title : null,
            space: {
                key: json?.content?.space?.key || null
            },
            _links: {
                editui: json?.content?._links?.editui || null
            },
            metadata: {
                properties: {
                    editor: {
                        value: json?.content?.metadata?.properties?.editor?.value || null
                    }
                },
                simple: {
                    isFabric: json?.content?.metadata?.simple?.isFabric || null
                }
            }
        }
    };
};
const $2dc0a210c1f3c9f7$export$ed7023388c8f5dd4 = async (cfetch, url, method, headers, pageData)=>{
    const MAX_CONTENT_UPDATE_RETRY = 1;
    const updateTemplate = async (count = 0)=>{
        try {
            const res = await cfetch(url, {
                method: method,
                headers: headers,
                body: JSON.stringify(pageData)
            });
            return res.json();
        } catch (err) {
            const errorStatus = err?.response?.status;
            if (errorStatus === 500) {
                const backendError = await err.response.json();
                throw new (0, $hBkCm.BadStatusError)(backendError.errorMessage, err.response);
            }
            if (count < MAX_CONTENT_UPDATE_RETRY && errorStatus === 409) return updateTemplate(++count);
            throw err;
        }
    };
    const json = await updateTemplate();
    return $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f(json);
};
const $2dc0a210c1f3c9f7$export$6a221318e0d372a4 = async (createPageResponseJson, attemptSpaUrl)=>{
    if (attemptSpaUrl) {
        // TODO: remove the old metadata field check once we use the new metadata field for template
        const isFabric = createPageResponseJson?.content?.metadata?.properties?.editor?.value === 'v2' || createPageResponseJson?.content?.metadata?.simple?.isFabric === true;
        const isLivePage = createPageResponseJson?.content?.subType === 'live';
        if (isLivePage) return createPageResponseJson?.content?._links?.editui;
        if (isFabric) return (0, $dw6y2.createEditDraftPageUrl)(createPageResponseJson);
    }
    return createPageResponseJson?.content?._links?.editui;
};
module.exports["getOnContentUpdatedObjFromResponse"] = $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f;
module.exports["getEditDraftPageUrl"] = $2dc0a210c1f3c9f7$export$6a221318e0d372a4;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});


//# sourceMappingURL=TemplatePanel.218a8692.js.map
